// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"PopoverTrigger__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/layouts/PopoverTriggerLayout/PopoverTrigger.scss
 ** module id = 955
 ** module chunks = 1
 **/